import getCountryISO3 from '../utils/CountryCodes/getCountryISO3FromISO2';
import format from '../utils/format';
import sanitizeLangText from '../utils/sanitize-lang-text';
import Track from '../utils/tracking';
import LanguageSource from './language-source';
import Locale from './locale';

const getTextFromDefault = (key) => {
  const source = LanguageSource.defaultLang();
  const text = source[key];
  return text || '';
};

const doesTranslationExist = key => !!getTextFromDefault(key);

const doTranslationsExist = keys => keys?.length > 0 && keys.every(doesTranslationExist);

const getText = (key, locale, embeddedValues) => {
  let text = getTextFromDefault(key);
  
  text = sanitizeLangText(text);
  
  if (embeddedValues) {
    let updatedEmbeddedValues = embeddedValues;
    if (!Array.isArray(embeddedValues)) {
      updatedEmbeddedValues = [embeddedValues];
    }
    text = format(text, updatedEmbeddedValues);
  }
  return text;
};

const formatLinkText = (text, linkProps) => {
  const splitText = text.split(/[\[\]]/);
  if (splitText.length === 3) {
    return (
      <>
        {splitText[0]}
        <a {...linkProps}>{splitText[1]}</a>
        {splitText[2]}
      </>
    );
  } // link syntax configured incorrectly.
  Track.warn(`link syntax configured incorrectly git for ${text}`);
  return text;
};

const getCountryName = (countryCode) => {
  if (!countryCode) return;
  const updatedCountryCode = countryCode.length === 2 ? getCountryISO3(countryCode) : countryCode;
  return Language.getText(`checkout.page.${updatedCountryCode.toLowerCase()}.text`);
};

const Language = {
  getText(key, embeddedValues) {
    if (!key) {
      Track.error('key is required to get language property');
    }
    return key ? getText(key, Locale.get(), embeddedValues) : '';
  },
  formatLinkText,
  getCountryName,
  doesTranslationExist,
  doTranslationsExist,
};

export default Language;
